import TactonImage from "@husky-hrc/Components/FormFields/TactonImage";
import { InputModel, InputType, isImageInput } from "@husky-hrc/Framework/Types/ApiModel";
import React from "react";

import HuskyTextField from "@husky-hrc/Components/FormFields/HuskyTextField";
import ImageButton from "@husky-hrc/Components/FormFields/ImageButton";
import SelectField from "@husky-hrc/Components/FormFields/SelectField";
import ToggleField from "@husky-hrc/Components/FormFields/ToggleField";

interface OwnProps {
    cssHideOrange: boolean;
    input: InputModel;
    onChange: (parameter: string, value: string) => void;
    onUncommit: (parameter: string) => void;
}

type Props = OwnProps;

const TactonInput = ({ cssHideOrange, input, onChange, onUncommit }: Props) => {
    let configurationField = <HuskyTextField input={input} onChange={onChange} onUncommit={onUncommit} />;

    if (input.type === InputType.TOGGLE) {
        configurationField = <ToggleField input={input} onChange={onChange} onUncommit={onUncommit} />;
    }

    if (input.type === InputType.SELECT) {
        configurationField = (
            <SelectField cssHideOrange={cssHideOrange} input={input} onChange={onChange} onUncommit={onUncommit} />
        );
    }

    if (input.type === InputType.IMAGE && isImageInput(input)) {
        configurationField = <TactonImage input={input} />;
    }

    if (input.type === InputType.IMAGE_SELECT && isImageInput(input)) {
        configurationField = <ImageButton input={input} onChange={onChange} onUncommit={onUncommit} />;
    }

    return configurationField;
};

export default TactonInput;
